// ユーザーのサービス可否の編集（portal.md「ユーザー管理」/ portal-api.md PATCH /contracts/{contractId}/users/{sub}）。
// メンバー画面のポップアップの中身。ほかの変更（権限・チーム・状態・除外など）は一覧で選んでまとめて行う。

import { useState } from "react";
import type { ContractRows, UserRow } from "../lib/api";
import { ServiceAccess } from "./shared";

export function ServiceEditor({ user, rows, error, onCancel, onSave }: {
  user: UserRow; rows: ContractRows; error: string | null; onCancel: () => void;
  onSave: (patch: { services: Record<string, boolean> | null }) => void;
}) {
  const [services, setServices] = useState<Record<string, boolean>>(user.services);
  return (
    <>
      <label>サービス可否（サービス利用が有効なサービスだけ設定できます）</label>
      <ServiceAccess subscriptions={rows.subscriptions} contractName={rows.contract.name} value={services} onChange={setServices} />
      {error && <p className="error">{error}</p>}
      <p className="row modal-actions">
        <span className="spacer" />
        <button onClick={onCancel}>キャンセル</button>
        <button className="primary" onClick={() => onSave({ services: Object.keys(services).length ? services : null })}>保存</button>
      </p>
    </>
  );
}
